import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  WorkspaceCodeStatus,
  getWorkspaceCodeStatuses,
} from '../../../../api/workspaces/invite/getWorkspaceCodeStatuses';

interface UseGetWorkspaceCodeStatusesParams<T = WorkspaceCodeStatus[]> {
  workspaceId: string;
  enabled?: boolean;
  select?: (statuses: WorkspaceCodeStatus[]) => T;
}

export function useGetWorkspaceCodeStatuses<T = WorkspaceCodeStatus[]>({
  workspaceId,
  enabled = true,
  select,
}: UseGetWorkspaceCodeStatusesParams<T>) {
  return useQuery({
    queryKey: workspaceKeys.codeStatuses(workspaceId),
    queryFn: () => getWorkspaceCodeStatuses(workspaceId),
    enabled: enabled && !!workspaceId,
    select,
  });
}
